import { MessageService } from 'primeng/api';
import { Observable } from 'rxjs';

import { EventEmitter, Injectable } from '@angular/core';

import { CloudFile } from '../models/cloudFile';
import { User } from '../models/user';
import { UserDomainService } from '../domains/user.service';

@Injectable()
export class ProfileService {
  loadingEvent = new EventEmitter();

  userAge: { age: number; str_age: string } = { age: 0, str_age: '' };
  profileFileSelector: EventEmitter<MouseEvent> = new EventEmitter();

  constructor(
    private messageService: MessageService,
    private userDomainService: UserDomainService
  ) {}

  loading(status: boolean) {
    this.loadingEvent.emit(status);
  }
}

